import React from "react";

const ArrowDownIcon = ({ color, ...rest }) => (
  <svg width="9px" height="5px" viewBox="0 0 9 5" version="1.1" {...rest}>
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="User-Management_users" transform="translate(-211.000000, -388.000000)" fill={color || "#FFFFFF"} fillRule="nonzero">
        <g id="sidebar_menu_1-copy">
          <g id="Group-2-Copy" transform="translate(0.000000, 359.000000)">
            <g id="arrow_down" transform="translate(215.500000, 31.500000) rotate(-270.000000) translate(-215.500000, -31.500000) translate(213.000000, 27.000000)">
              <path
                d="M0.183058262,0.188288498 C0.402728176,-0.0376576996 0.745234938,-0.0602523193 0.989472222,0.120504639 L1.06694174,0.188288498 L4.81694174,4.04543135 C5.03661165,4.27137755 5.05857864,4.62367022 4.88284271,4.87488571 L4.81694174,4.95456865 L1.06694174,8.8117115 C0.822864056,9.06276283 0.427135944,9.06276283 0.183058262,8.8117115 C-0.0366116524,8.5857653 -0.0585786438,8.23347264 0.117157288,7.98225714 L0.183058262,7.90257421 L3.4909375,4.5 L0.183058262,1.09742579 C-0.0366116524,0.871479591 -0.0585786438,0.519186921 0.117157288,0.267971429 L0.183058262,0.188288498 Z"
                id="arrow"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default ArrowDownIcon;
